import React from 'react';
import PropTypes from 'prop-types';

import { ImageStyled } from './Image.styled';

export default function Image({ className, src, alt, sx }) {
  return (
    <picture src={src} alt={alt}>
      {/* TODO: Pass source tags to the component for serving different images according to viewport */}
      <ImageStyled className={className} src={src} alt={alt} style={sx} />
    </picture>
  );
}

Image.propTypes = {
  sx: PropTypes.shape({}),
  className: PropTypes.string,
  /**
   * URL for the image
   */
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Alternative text for the image
   */
  alt: PropTypes.string,
};
